import React from 'react';
import PublicSEO from '../../components/public/PublicSEO';
import { buildBreadcrumb, buildWebPage } from '../../utils/jsonLd';
import './LegalPages.css';

const CookiePolicyPage = () => {
  return (
    <div className="vc-legal-page cookie-policy-page">
      <PublicSEO
        title="Cookie Policy"
        description="Cookie Policy di Virtual Clinic: come utilizziamo i cookie sul sito. Gestione preferenze e link alle guide dei browser."
        canonicalPath="/cookie-policy"
        jsonLd={[
          buildWebPage({
            canonicalPath: '/cookie-policy',
            name: 'Cookie Policy',
            description: 'Politica sui cookie utilizzati dal sito Virtual Clinic.',
          }),
          buildBreadcrumb([
            { name: 'Home', path: '/' },
            { name: 'Cookie Policy' },
          ]),
        ]}
      />
      <div className="container vc-legal-inner">
        <h1>Cookie Policy</h1>
        <p className="vc-legal-date">Effective Date: 16-Mar-2025 · Last Updated: 16-Mar-2025</p>

        <h5>What are cookies?</h5>
        <p>This Cookie Policy explains what cookies are and how we use them, the types of cookies we use, the information we collect using cookies and how that information is used, and how to manage the cookie settings.</p>
        <p>Cookies are small text files that are used to store small pieces of information. They are stored on your device when the website is loaded on your browser. These cookies help us make the website function properly, make it more secure, provide better user experience, and understand how the website performs and to analyze what works and where it needs improvement.</p>

        <h5>How do we use cookies?</h5>
        <p>As most of the online services, our website uses first-party and third-party cookies for several purposes. First-party cookies are mostly necessary for the website to function the right way, and they do not collect any of your personally identifiable data.</p>
        <p>The third-party cookies used on our website are mainly for understanding how the website performs, how you interact with our website, keeping our services secure, providing advertisements that are relevant to you, and all in all providing you with a better and improved user experience and help speed up your future interactions with our website.</p>

        <h5>Manage cookie preferences</h5>
        <p>You can change your cookie preferences at any time. When you first visit our site, the CookieYes consent banner allows you to accept or refuse cookies. To change your preferences later, you can clear your browser cookies for this site and reload the page to see the banner again, or use your browser settings to block or delete cookies.</p>
        <p>Different browsers provide different methods to block and delete cookies. Below are the links to the support documents for the main browsers:</p>
        <ul>
          <li>Chrome: <a href="https://support.google.com/accounts/answer/32050" target="_blank" rel="noopener noreferrer">Manage cookies in Chrome</a></li>
          <li>Safari: <a href="https://support.apple.com/en-in/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Manage cookies in Safari</a></li>
          <li>Firefox: <a href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox" target="_blank" rel="noopener noreferrer">Clear cookies in Firefox</a></li>
          <li>Internet Explorer: <a href="https://support.microsoft.com/en-us/topic/how-to-delete-cookie-files-in-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc" target="_blank" rel="noopener noreferrer">Delete cookies in Internet Explorer</a></li>
        </ul>
        <p>If you use another browser, please refer to its official support documentation.</p>

        <p className="vc-legal-date">
          Cookie Policy generated with <a href="https://www.cookieyes.com/" target="_blank" rel="noopener noreferrer">CookieYes - Cookie Policy Generator</a>.
        </p>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
